import { Box } from '@st/document-rendering'
import { RectangleAnnotation } from '@st/sdk'
import { memo } from 'react'

type Props = {
  annotation: RectangleAnnotation
}

function RectangleViewBase({ annotation }: Props) {
  return (
    <Box
      width={annotation.bounds.width}
      height={annotation.bounds.height}
      border={{ color: annotation.border.color ?? '#000', width: annotation.border.width ?? 1 }}
    />
  )
}

export const RectangleView = memo(RectangleViewBase)
